<template>
  <div>
    <el-card body-style="padding: 0">
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="登录名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入登录名"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="登录类型" prop="status">
              <el-select v-model="queryForm.status" clearable placeholder="请选择登录类型">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="tableData"
                border
                default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="loginName" label="登录名"/>
        <el-table-column prop="loginType" label="登录类型">
          <template slot-scope="scope">
            <span>{{ scope.row.loginType == 0 ? "电脑端" : "手机端" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="loginInfo" label="登录信息">
          <template slot-scope="scope">
            <div v-html="scope.row.loginInfo"></div>
          </template>
        </el-table-column>
        <el-table-column prop="loginIp" label="登录IP"/>
        <el-table-column prop="loginTime" label="登录时间"/>
        <el-table-column prop="remarks" label="备注"/>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryLoginLogs} from "../../api/system/sys_user";

export default {
  name: "LoginLogManagelist",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryFormRefName: "queryForm",
      queryForm: {
        userName: null,
        status: null,
        timeRange: null
      },
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.tableHeight = document.body.clientHeight - 220;
    this.getData();
  },
  methods: {
    getData() {
      queryLoginLogs(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
